export const DataList = ({
  array,
  idPregunta,
  handleHiddenQ,
  subpreguntaid,
}) => {
  const options = array.map((option) => (
    <option
      key={option.RespuestaId}
      id={option.RespuestaId}
      name={idPregunta}
      subpreguntaid={option.RespuestaTexto == "Otros" ? subpreguntaid : 0}
    >
      {option.RespuestaTexto}
    </option>
  ));
  return (
    <>
      <input list="datalist" name="zona" id="zona"></input>
      <datalist id="datalist" name={idPregunta} onChange={handleHiddenQ}>
        {/* <option name={idPregunta} defaultValue>
        Elige una opción
      </option> */}
        {options}
      </datalist>
    </>
  );
};
